import React, { useRef, useEffect, Fragment } from 'react'
import { getImagen } from '../../actions/imagen'
import Spinner from '../layout/Spinner'
import { cargarParametros } from '../../helpers/funciones'
import { useDispatch, useSelector } from 'react-redux'

let src_pers = ''
let parametros_usados = ['img_cargadas']
let parametros

const Imagen = props => {
  const dispatch = useDispatch()
  const imagenes = useSelector(state => state.imagen.imagenes)
  const portal = useSelector(state => state.portal.portal)
  const prevProps = useRef()

  useEffect(() => {
    prevProps.current = props
    if (
      !imagenes?.[props.codigo_articulo]?.[props.numero_imagen] ||
      imagenes[props.codigo_articulo][props.numero_imagen].error
    ) {
      dispatch(
        getImagen(
          props.codigo_articulo,
          props.numero_imagen ? props.numero_imagen : 1,
          props.principal ? props.principal : 'S',
          parametros.img_cargadas,
        ),
      )
    }
  }, [])

  useEffect(() => {
    if (
      prevProps?.current?.codigo_articulo !== props.codigo_articulo ||
      prevProps?.current?.numero_imagen !== props.numero_imagen
    ) {
      if (
        !imagenes?.[props.codigo_articulo]?.[props.numero_imagen] ||
        imagenes[props.codigo_articulo][props.numero_imagen].error
      ) {
        dispatch(
          getImagen(
            props.codigo_articulo,
            props.numero_imagen ? props.numero_imagen : 1,
            props.principal ? props.principal : 'S',
            parametros.img_cargadas,
          ),
        )
      }
    }
    prevProps.current = props
  }, [props])

  const cargarSRCImagenes = () => {
    if (
      imagenes[props.codigo_articulo] &&
      imagenes[props.codigo_articulo][props.numero_imagen] &&
      imagenes[props.codigo_articulo][props.numero_imagen].articulo_referencia &&
      imagenes[props.codigo_articulo][props.numero_imagen].articulo_referencia !== ''
    ) {
      //Imagen de articulo referencia
      console.log(imagenes[props.codigo_articulo][props.numero_imagen])
      src_pers = imagenes[props.codigo_articulo][props.numero_imagen].path
    } else if (
      //Imagen propia
      imagenes[props.codigo_articulo] &&
      imagenes[props.codigo_articulo][props.numero_imagen] &&
      (imagenes[props.codigo_articulo][props.numero_imagen].articulo_referencia ||
        imagenes[props.codigo_articulo][props.numero_imagen].articulo_referencia === '' ||
        imagenes[props.codigo_articulo][props.numero_imagen].articulo_referencia === null)
    ) {
      console.log(imagenes[props.codigo_articulo][props.numero_imagen])
      src_pers = imagenes[props.codigo_articulo][props.numero_imagen].path
    } else {
      //No encuentra imagen
      src_pers = '/assets/img/placeholder.jpg'
    }
  }

  parametros = cargarParametros(parametros_usados, portal.parametros_ecom, 'GEN')
  if (parametros && parametros.img_cargadas === 'S') {
    if (
      imagenes[props.codigo_articulo] &&
      imagenes[props.codigo_articulo][props.numero_imagen] &&
      imagenes[props.codigo_articulo][props.numero_imagen].isLoading
    ) {
      return <Spinner showSpinner={true} />
    } else {
      cargarSRCImagenes()
      return (
        <Fragment>
          <img
            style={{ maxWidth: '100%', maxHeight: '100%' }}
            src={src_pers}
            data-src={src_pers}
            alt=''
            onError={event => {
              event.target.src = '/assets/img/placeholder.jpg'
              event.onerror = 'null'
            }}
          />
        </Fragment>
      )
    }
  } else if (
    imagenes[props.codigo_articulo] &&
    imagenes[props.codigo_articulo][props.numero_imagen] &&
    imagenes[props.codigo_articulo][props.numero_imagen].isLoading
  ) {
    return <Spinner showSpinner={true} />
  } else if (
    imagenes[props.codigo_articulo] &&
    imagenes[props.codigo_articulo][props.numero_imagen] &&
    imagenes[props.codigo_articulo][props.numero_imagen].imagen !== ''
  ) {
    return (
      <Fragment>
        <img
          src={imagenes[props.codigo_articulo][props.numero_imagen].imagen.path}
          data-src={imagenes[props.codigo_articulo][props.numero_imagen].imagen.path}
          alt=''
        />
      </Fragment>
    )
  } else {
    return (
      <Fragment>
        <img
          src='/assets/img/placeholder.jpg'
          data-src='/assets/img/placeholder.jpg'
          alt=''
        />
      </Fragment>
    )
  }
}

export default Imagen
